import request from '@/utils/request'

// 获取商品列表
export function getProductList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryAdminProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取入库记录
export function getInstockList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder.queryAdminInoutOrder',
      method: 'get',
      params: {
        ...params,
        orderType: '10000' // 入库类型
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取出库记录
export function getOutstockList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder.queryAdminInoutOrder',
      method: 'get',
      params: {
        ...params,
        orderType: '20000' // 出库类型
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取秒杀商品列表
export function getSeckillList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listAdminSeckill',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}